import { ReactElement } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';

export interface Props extends ClassNamePropsWithChildren {
  CKEditorConfig?: {
    [key: string]: string;
  };
  projectId: number;
  documentId: number;
  canShowComments?: boolean;
  wrapperClassName?: string;
  topbarClassName?: string;
  editorClassName?: string;
  onDocumentTitleChange?: (title: string) => void;
  renderExtraToolbarOptions?: () => ReactElement;
  isPrivate?: boolean;
  isResponsive?: boolean;
}

export enum TabNames {
  CommentsTab = 'comments',
  ConversationsTab = 'conversations',
  Tasks = 'tasks',
  Approvals = 'approvals',
}

export interface FreezeAction {
  frozen: boolean;
  frozenAt?: string;
  frozenBy?: number;
}
